const REVIEWS = [
    {
        name: "Catherine M.",
        city: "Lyon",
        rating: 5,
        text: "Intervention en 20 min un dimanche soir. Porte claquée ouverte sans aucun dégât. Très professionnel et sympathique.",
        service: "Ouverture de porte",
        date: "Décembre 2025",
    },
    {
        name: "Jean-Pierre L.",
        city: "Toulouse",
        rating: 5,
        text: "Clé cassée dans la serrure à 23h. Arrivé en 30 minutes, tarif annoncé respecté au centime près. Parfait.",
        service: "Dépannage",
        date: "Novembre 2025",
    },
    {
        name: "Sophie R.",
        city: "Nantes",
        rating: 5,
        text: "Remplacement d'une serrure A2P après effraction. Travail soigné, facture claire, conseils précieux pour la sécurité.",
        service: "Remplacement serrure",
        date: "Novembre 2025",
    },
    {
        name: "Marc D.",
        city: "Bordeaux",
        rating: 5,
        text: "Pose d'une porte blindée. Devis respecté, équipe ponctuelle et minutieuse. Je recommande vivement.",
        service: "Porte blindée",
        date: "Octobre 2025",
    },
    {
        name: "Valérie B.",
        city: "Lille",
        rating: 5,
        text: "A dépanné mon père de 85 ans en pleine nuit, serrure grippée. Patient, pédagogue, tarif très raisonnable. Merci !",
        service: "Dépannage 24/7",
        date: "Octobre 2025",
    },
    {
        name: "Nicolas P.",
        city: "Strasbourg",
        rating: 5,
        text: "Porte bloquée le matin avant le travail. Artisan arrivé en 25 min, réparation rapide. Excellent service.",
        service: "Ouverture de porte",
        date: "Septembre 2025",
    },
];

export default REVIEWS;
